import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import VueMask from 'v-mask'

import '@/styles/custom.scss';

Vue.config.productionTip = false

Vue.use(VueMask);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
